import React from 'react'

import { Entity } from 'shared-libs/models/entity'

// Threads UI-driven required-field state from EntityFormBlock down into the
// schema-rendered tree so nested creation flows (e.g. DocumentCreationFlow)
// can render the error summary banner INSIDE the schema's ui:panel body —
// under the panel title bar — instead of above the panel wrapper.
export interface IEntityFormValidationContext {
  entity: Entity | null
  errors: any
  hasSubmitted: boolean
  uiErrors: Record<string, string[]>
  // Optional map from valuePath → the field's UI label. Populated alongside
  // `uiErrors` by the renderer so the summary banner can display the label
  // ("Required Test") instead of the raw path.
  uiErrorLabels?: Record<string, string>
}

export const EntityFormValidationContext = React.createContext<IEntityFormValidationContext>({
  entity: null,
  errors: null,
  hasSubmitted: false,
  uiErrors: {},
  uiErrorLabels: {},
})
